import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Box, Button } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';
import DealerCodeDialog from './DealerDialog';
import useDealers from 'src/hooks/useDealers';

const useStyles = makeStyles((theme) => ({
  loader: {
    marginRight: theme.spacing(2),
    borderRadius: theme.spacing(1),
    backgroundColor: 'rgb(113, 156, 203, 0.25)'
  },
  menuButton: {
    borderRadius: theme.spacing(1),

    '&:disabled': {
      color: 'inherit',
      borderColor: 'inherit',
    },
  }
}));

function DealerMenuButton() {
  const classes = useStyles();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { user } = useSelector(state => state.account);

  const { activeDealer } = useDealers();

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  }

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  }

  if (!activeDealer) {
    return (
      <Skeleton
        className={classes.loader}
        variant="rect"
        width={190}
        height={36}
      />
    );
  }

  const canUserRoam = user?.agents?.length > 1;
  return (
    <>
      <Box mr={2}>
        <Button
          disabled={!canUserRoam}
          onClick={handleOpenDialog}
          variant="outlined"
          color="inherit"
          className={classes.menuButton}
          {...canUserRoam
            ? { endIcon: <ExpandMoreIcon fontSize="small" /> }
            : {}
          }
        >
          {activeDealer?.name}
        </Button>
      </Box>
      <DealerCodeDialog
        isOpen={isDialogOpen}
        onClose={handleCloseDialog}
      />
    </>
  );
}

export default DealerMenuButton;
